import RpmReadingsPanel, { useRpmReadings } from "./RpmReadingsPanel";

// Dashboard -> Chart -> RPM tab. The readings view itself is shared with the
// standalone RPM module (RpmReadingsPanel.jsx).
const RPM = ({ dataId }) => {
  const { rpmData, wlmData, isLoading } = useRpmReadings(dataId?.patientid);

  return (
    <div className="flex flex-col h-auto w-[98%] max-h-[70vh] p-3 pr-6 pl-6 mb-16 bg-[white] rounded-xl overflow-y-auto custom-scrollbar">
      <RpmReadingsPanel rpmData={rpmData} wlmData={wlmData} isLoading={isLoading} />
    </div>
  );
};

export default RPM;
